/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkspaceCreateRequest
 */
export interface WorkspaceCreateRequest {
    /**
     * Name of the workspace
     * @type {string}
     * @memberof WorkspaceCreateRequest
     */
    name: string;
    /**
     * URL of the avatar of this workspace (used in the UI)
     * @type {string}
     * @memberof WorkspaceCreateRequest
     */
    avatarUrl: string;
}

/**
 * Check if a given object implements the WorkspaceCreateRequest interface.
 */
export function instanceOfWorkspaceCreateRequest(value: object): value is WorkspaceCreateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('avatarUrl' in value) || value['avatarUrl'] === undefined) return false;
    return true;
}

export function WorkspaceCreateRequestFromJSON(json: any): WorkspaceCreateRequest {
    return WorkspaceCreateRequestFromJSONTyped(json, false);
}

export function WorkspaceCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspaceCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'avatarUrl': json['avatarUrl'],
    };
}

export function WorkspaceCreateRequestToJSON(json: any): WorkspaceCreateRequest {
    return WorkspaceCreateRequestToJSONTyped(json, false);
}

export function WorkspaceCreateRequestToJSONTyped(value?: WorkspaceCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'avatarUrl': value['avatarUrl'],
    };
}

